import { render, staticRenderFns } from "./OrderDataForm.vue?vue&type=template&id=4188aa98&scoped=true&"
import script from "./OrderDataForm.vue?vue&type=script&lang=js&"
export * from "./OrderDataForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderDataForm.vue?vue&type=style&index=0&id=4188aa98&lang=scss&scoped=true&"
import style1 from "./OrderDataForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188aa98",
  null
  
)

export default component.exports